import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import BaseComponent from '../../../../baseClasses/BaseComponent';
import AnalyticsLogger from '../../../../helpers/analytics/analyticsLogger';
import fileTypeImageIcon from '../../../../assets/images/photo-icon.svg';
import fileTypeQuestionIcon from '../../../../assets/images/question-icon.svg';
import fileTypeFormIcon from '../../../../assets/images/forms-icon.svg';
import ImageTools from '../../../../helpers/ImageTools';
import fileTypeCheckoff from '../../../../assets/images/checkoff-icon.svg';
import dataModel from '../../../../models/DataModel';
import TaskCompletionStepInfoMobile from './TaskCompletionStepInfoMobile';
import arrowIcon from '../../../../assets/images/caret-white.svg';
import revertIcon from '../../../../assets/images/revert-arrow.svg';
import { completion_criteria_root } from '../../../../dao/CompletionCriteriaDAO';
import DataSource from '../../../../dao/DataSource/DataSource';
import './TaskCompletionStepDetails.scss';

const completionStepDescriptor = {
  completion_criterion: {
    attachments: { additionalFields: ['upload', 'photo_longitude', 'photo_latitude', 'photo_taken_at'] } ,
    comments: {},
  },
};

export class TaskCompletionStepDetails extends BaseComponent {
  constructor(props) {
    super(props);
    this.revertCompletionStep = this.revertCompletionStep.bind(this);
    
    const currentRole = props.currentUser ? props.currentUser.role : null;
    this.analyticsLogger = new AnalyticsLogger({
      currentRole,
      isMobile: !!window.cordova,
    });

    this.switchCS = this.switchCS.bind(this);
  }

  handleCompletionStepRetrieval(completionStep, action, acData) {
    this.setState({ completionStep });
  }

  componentDidMount() {
    const { completionStep } = this.props;
    if (completionStep) {
      this.completionStepDataSource = new DataSource('CompletionCriterion', completionStep, completion_criteria_root, this.handleCompletionStepRetrieval);
      this.completionStepDataSource.get();
    }
  }

  componentWillUnmount() {
    if (this.completionStepDataSource) {
      this.completionStepDataSource.release();
      this.completionStepDataSource = null;
    }    
  }

  componentDidUpdate(prevProps){
    if (prevProps.completionStep != this.props.completionStep) {
      if (this.completionStepDataSource) {
        this.completionStepDataSource.release();
      }

      this.completionStepDataSource = new DataSource('CompletionCriterion', this.props.completionStep, completion_criteria_root, this.handleCompletionStepRetrieval);
      this.completionStepDataSource.get();
    }
  }

  revertCompletionStep() {
    dataModel.showGlobalModal('SYSTEM_POPUP', {
      message: 'Are you sure you want to revert '+this.state.completionStep.name+'? Work has begun on this Completion Step. This action cannot be undone.',
      width: 320,
      height: 184,
      okButtonText: 'YES',
      handleOwnerOk: () => {
        this.analyticsLogger.logReversalEvent();
        dataModel.completionCriteriaDAO.revertCompletionCriterion(this.state.completionStep, true, true, null, { recordDescriptor: completionStepDescriptor })
          .then(error => {
            if (typeof error != 'undefined') { 
              // TODO: anything?
            }
          });
      },
    });
  }

  handleGetStatus(task, completionStep) {
    if (!task.has_field_user && ! task.has_reviewer && !task.has_approver) {
      return { text: 'Not Started', css: 'not-started' };
    }

    if (
      completionStep.rejected_at &&
      !completionStep.approved_at &&
      !completionStep.reviewed_at &&
      !completionStep.completed_at
    ) {
      return { text: 'Rejected', css: 'rejected' };
    } else if (!completionStep.completed_at) {
      return { text: 'Not Started', css: 'not-started' };
    } else if (!completionStep.reviewed_at && task.has_reviewer) {
      return { text: 'Pending Review', css: 'pending' };
    } else if (!completionStep.approved_at && task.has_approver) {
      return { text: 'Pending Approval', css: 'pending' };
    } else if (completionStep.approved_at) {
      return { text: 'Approved', css: 'approved' };
    } else {
      return { text: 'Completed', css: 'approved' };
    }
  }

  fixExtension(extension) {
    let markStart = extension.indexOf('?');
    if (markStart >= 0) {
      extension = extension.substring(0, markStart);
    }
    return extension;
  }

  createNextCSArrow(isLeft) {
    const { task } = this.props;
    const { completionStep } = this.state;

    const firstCSId = task.completion_criteria[0].id ? task.completion_criteria[0].id : task.completion_criteria[0];
    const lastCSId = task.completion_criteria[task.completion_criteria.length - 1].id ? task.completion_criteria[task.completion_criteria.length - 1].id : task.completion_criteria[task.completion_criteria.length - 1];
    //check if isLeft arrow and not first cs step
    if (isLeft && firstCSId != completionStep.id) {
      return (
        <div className='next-button-container next-button-container--left'>
          <img  alt='switch'
            src={arrowIcon} 
            className='next-cs-button' 
            onClick={() => this.switchCS(false)}
          />
        </div>
      );
    }
    //check if this is the right arrow and not last cs step
    else if (!isLeft && lastCSId != completionStep.id) {
      return (
        <div className='next-button-container next-button-container--right'>
          <img alt="switch"
            src={arrowIcon} 
            className='next-cs-button' 
            onClick={() => this.switchCS(true)}
          />
        </div>
      );
    }
    else {
      return null;
    }
  }

  switchCS(goToNextCS) {
    //handle push to next cs
    const { task } = this.props;
    const { completionStep } = this.state;

    const firstCSId = task.completion_criteria[0].id ? task.completion_criteria[0].id : task.completion_criteria[0];
    const lastCSId = task.completion_criteria[task.completion_criteria.length - 1].id ? task.completion_criteria[task.completion_criteria.length - 1].id : task.completion_criteria[task.completion_criteria.length - 1];

    //check if switch is able to go to next or previous cs
    let performSwitch = false;
    if (goToNextCS && lastCSId != completionStep.id) {
      performSwitch = true;
    }
    else if (!goToNextCS && firstCSId != completionStep.id) {
      performSwitch = true;
    }

    if (performSwitch)  { //check for auto progression to next cs via handsfree in checkoff
      let nextCSIndex = task.completion_criteria.findIndex(cs => cs.id ? cs.id == completionStep.id : cs == completionStep.id);
      goToNextCS ? nextCSIndex++ : nextCSIndex--;
      const nextCSId = task.completion_criteria[0].id ? task.completion_criteria[nextCSIndex].id : task.completion_criteria[nextCSIndex];
      this.props.history.push({
        pathname: `/mobile/projects-tasks/task/${task.id}/completion_step/${nextCSId}`,
      });
    }
    return performSwitch;
  }

  createNavigationContainer() {
    const { currentCompany, task } = this.props;
    const { completionStep } = this.state;
    if (currentCompany.features && currentCompany.features.hands_free && currentCompany.features.hands_free.enabled && dataModel.getHandsFreeFlag()) {
      const leftArrow = this.createNextCSArrow(true);
      const rightArrow = this.createNextCSArrow(false);
      
      let currentCSIndex = task.completion_criteria.findIndex(cs => cs.id ? cs.id == completionStep.id : cs == completionStep.id) + 1;

      return (
        <div className='cs-navigator-container'>
          { leftArrow }
          <p>
            {'Completion Step ' + currentCSIndex +  '/' + task.completion_criteria.length}
          </p>
          { rightArrow }
        </div>
      );
    }
    else {
      return null;
    }
  }
  
  handleChildCompletionStepUpdate(completionStep) {
    this.setState({ completionStep });
  }

  render() {
    const { task, action, userStepPermissions } = this.props;
    const { completionStep } = this.state;
    if (!task || !completionStep) {
      return null;
    }
    const status = this.handleGetStatus(task, completionStep);
    
    let revertButton = null;
    if (completionStep && (this.props.isBuildOwner || this.props.isProjectManager) && (completionStep.completed_at || completionStep.rejected_at)) {
      revertButton = (
        <div className="revert-button-container" onClick={this.revertCompletionStep} >
          <img className="revert-button" src={revertIcon} alt="revert-button" />
          <div className="revert-text">Revert</div>
        </div>
      );
    }

    let typeImage = fileTypeImageIcon;
    if (completionStep.completion_type == 'boolean') {
      typeImage = fileTypeCheckoff;
    } 
    else if (completionStep.completion_type == 'inspection') {
      typeImage = fileTypeQuestionIcon;
    }
    else if (completionStep.completion_type == 'form') {
      typeImage = fileTypeFormIcon;
    } 
    else if (completionStep.requested_file_type){
      typeImage = ImageTools.getIconForFile(completionStep.requested_file_type);
    }

    const stepNavigationContainer = this.createNavigationContainer();

    return (
      <div className="task-completion-step-details">
        {revertButton}
        <div className="completion-step-details">
          <div className={'task-details' + (revertButton ? ' has-revert' : '')}>
            <div className="task-name">{task.name.toUpperCase()}</div>
            <div className="project-name">
              {task.project && task.project.name ? task.project.name : 'No project name'}
            </div>
          </div>
          <div className="completion-step-info">
            <img alt="completion step type icon" className="type-image" src={typeImage} />
            <div className="completion-step-name">{completionStep.name.toUpperCase()}</div>
            <div className={'step-status ' + status.css}>{status.text}</div>
          </div>
          <div className="completion-step-instructions">
            {completionStep.instructions && <div className="instructions-heading">
              {completionStep.completion_type == 'inspection' ? 'Question' : 'Instructions'}
              </div>}
            <div className="instructions">
              {completionStep.instructions ? completionStep.instructions : ''}
            </div>
        </div>
      </div>
        {stepNavigationContainer}
        <TaskCompletionStepInfoMobile
          project={task.project}
          task={task}
          completionStep={completionStep}
          setOverrideBackPath={this.props.setOverrideBackPath}
          action={action}
          completionStepStatus={status.text}
          userStepPermissions={userStepPermissions}
          handleChildCompletionStepUpdate={this.props.handleChildCompletionStepUpdate}
          handleFileSelected={this.props.handleFileSelected}
          switchCS={this.switchCS}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    currentUser: state.new_users ? state.new_users.currentUser : null,
    currentCompany: state.new_companies.currentCompany,
    handsFreeMode: state.main.handsFreeMode,
  };
};

export default withRouter(connect(mapStateToProps)(TaskCompletionStepDetails));



// WEBPACK FOOTER //
// ./src/containers/TasksContainer/MobileTaskDetails/TaskCompletionStepDetails/index.js